import { z } from 'zod/mini';

export const listPaginationSearchSchema = z.object({
    pageNum: z.optional(z.catch(z.int().check(z.nonnegative()), 0)),
    pageSize: z.optional(
        z.catch(
            z.int().check(
                z.minimum(25),
                z.maximum(100),
                z.refine(
                    (value) => {
                        switch (value) {
                            case 25:
                            case 50:
                            case 100:
                                return true;
                            default:
                                return false;
                        }
                    },
                    { error: 'Invalid page size' }
                )
            ),
            (ctx) => (ctx.issues[0].code === 'too_big' ? 100 : 25)
        )
    ),
});

export type TListPaginationSearchSchema = z.infer<typeof listPaginationSearchSchema>;
